import { useMemo, useState } from 'react';
import { withNamespaces } from 'react-i18next';

import { CyberSecurityStatuses } from '../../constants';

const filters = [
    { key: 'all', label: 'All Findings' },
    { key: 'failed', label: 'Failed' },
    { key: 'warning', label: 'Warnings' },
];

const OverviewFindings = ({
    findings,
    onSelectFinding,
    selectedFindingId,
    summary,
    t,
}) => {
    const [activeFilter, setActiveFilter] = useState('all');
    const visibleFindings = useMemo(() => {
        if (activeFilter === 'all') return findings;
        if (activeFilter === 'failed') {
            return findings.filter((finding) => (
                finding.status === 'failed' || finding.status === 'critical'
            ));
        }

        return findings.filter((finding) => finding.status === 'warning');
    }, [activeFilter, findings]);

    return (
        <div>
            <div className="d-flex flex-wrap align-items-center gap-2 mb-4">
                {filters.map((filter) => {
                    const count = filter.key === 'all'
                        ? findings.length
                        : filter.key === 'failed'
                            ? findings.filter((finding) => (
                                finding.status === 'failed' || finding.status === 'critical'
                            )).length
                            : findings.filter((finding) => finding.status === 'warning').length;

                    return (
                        <button
                            className={`cyber-filter ${activeFilter === filter.key ? 'is-active' : ''}`}
                            key={filter.key}
                            onClick={() => setActiveFilter(filter.key)}
                            type="button"
                        >
                            {`${t(filter.label)} (${count})`}
                        </button>
                    );
                })}
            </div>

            <div className="d-flex flex-wrap align-items-start justify-content-between gap-3 mb-3">
                <div>
                    <h5 className="mb-1">{t('Cyber Security Findings')}</h5>
                    <p className="text-muted mb-0">
                        {t('Key issues that affected the cyber security result for this bid.')}
                    </p>
                </div>

                <div className="cyber-summary">
                    <span>
                        <i className="ri-checkbox-circle-fill text-success" />
                        {summary.passed}
                        <small>{t('Passed')}</small>
                    </span>
                    <span>
                        <i className="ri-error-warning-fill text-warning" />
                        {summary.warnings}
                        <small>{t('Warnings')}</small>
                    </span>
                    <span>
                        <i className="ri-close-circle-fill text-danger" />
                        {summary.failed}
                        <small>{t('Failed')}</small>
                    </span>
                </div>
            </div>

            {visibleFindings.map((finding) => {
                const status = CyberSecurityStatuses[finding.status];

                return (
                    <button
                        className={`cyber-finding cyber-finding-${status.color} ${selectedFindingId === finding.id ? 'is-active' : ''}`}
                        key={finding.id}
                        onClick={() => onSelectFinding(finding)}
                        type="button"
                    >
                        <i className={`${status.icon} ${status.className}`} />
                        <span className="text-start">
                            <span className="d-block fw-medium">{t(finding.title)}</span>
                            <span className="d-block font-size-12 text-muted mb-1">
                                {t(finding.category)}
                                <span className={`${status.className} ms-2`}>
                                    <i className={`${status.icon} align-middle me-1`} />
                                    {t(status.title)}
                                </span>
                            </span>
                            <span className="d-block font-size-12 text-muted">{t(finding.summary)}</span>
                        </span>
                    </button>
                );
            })}
        </div>
    );
};

export default withNamespaces()(OverviewFindings);
